import { render, staticRenderFns } from "./ChildZoneListPageDialog.vue?vue&type=template&id=8bc96b8e&scoped=true"
import script from "./ChildZoneListPageDialog.vue?vue&type=script&lang=js"
export * from "./ChildZoneListPageDialog.vue?vue&type=script&lang=js"
import style0 from "./ChildZoneListPageDialog.vue?vue&type=style&index=0&id=8bc96b8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc96b8e",
  null
  
)

export default component.exports